// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"o2-z","colorTextValue":"p2-z","swatches":"q2-z","collapseLink":"r2-z","isCollapsed":"s2-z","dropdown":"t2-z","disabled":"u2-z"};